import ArrowLeft from "mdi-material-ui/ArrowLeft";
import HiIconButton from "@hipay/hipay-material-ui/HiIconButton";

export const GoBackBtn = (props) => (
    <HiIconButton id="go-back-btn" onClick={props.onClick} color={props.color} title={props.title}>
        <ArrowLeft color="inherit" />
    </HiIconButton>
);
